<template>
<div>
    <block-wrap v-for="item in options"
                :key="item.id"
                :adaptive="adaptive"
                :take-width="takeWidth"
                :step-fields-count="stepFieldsCount">
        <div class="odr-field">
            <div class="odr-field__control">
                <div class="odr-radio">
                    <input :id="id + '.' + item.id"
                           ref="radio"
                           type="radio"
                           :checked="value === item.id"
                           :name="id"
                           :value="item.id"
                           class="odr-radio__input"
                           :data-qa="dataQa ? item.id + '.' + dataQa : null"
                           @change="handleChange"
                           @focus="() => {$emit('focus')}"
                           @blur="() => {$emit('blur')}">
                    <div class="odr-radio__control">
                        <div class="odr-radio__checkmark"/>
                    </div>
                </div>
            </div>

            <label :for="id + '.' + item.id" class="odr-field__label">
                <tpl :content="(item.description || item.title || item.match)"/>
            </label>
        </div>
    </block-wrap>

    <div v-if="validation_showError && validation_error"
         class="odr-error-message"
         :class="{
             'odr-error-message_plain': $root.appConfig.mode !== 'chat'
         }">
        {{ validation_error }}
    </div>
</div>
</template>

<script>
import '@/scss/blocks/field.scss';
import '@/scss/blocks/radio.scss';

import validationMixin from '@/utils/mixins/validation';
import focusMixin from '@/utils/mixins/focus';
import orderMixin from '@/utils/mixins/order';

export default {
    mixins: [validationMixin, focusMixin, orderMixin],
    props: {
        dataQa: {},
        id: {},
        value: {},
        values: {},
        title: {},
        adaptive: {},
        takeWidth: {},
        stepFieldsCount: {},
    },
    data () {
        return {
            input: this.value,
        };
    },
    computed: {
        options () {
            return this.order_options(this.values);
        },
    },
    watch: {
        input () {
            this.validation_changed();
        },
    },
    methods: {
        handleChange (event) {
            this.input = event.target.value === '' ? null : event.target.value;
            this.$emit('input', this.input);
        },
        validation_isEmpty () {
            return !this.input;
        },
        focus_focus () {
            this.$refs.radio[0].focus({ preventScroll: true });
        },
    },
    components: {
        tpl: require('@/vue/markup/tpl.vue').default,
        'block-wrap': require('@/vue/block-wrap.vue').default,
    },
};
</script>
